import React from 'react';

import { styled } from '@mui/material';
import PropTypes from 'prop-types';

const Div_Wrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'withBackground',
})(({ theme, withBackground }) => ({
  width: '100%',
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1000,
  bottom: 0,
  right: 0,
  textAlign: 'center',
  ...(withBackground && {
    backgroundColor: `${theme.palette.background.dark}1A`,
  }),
  '& .loading-indicator-spinner': {
    animation: 'loading-indicator-spin 1s linear infinite',
  },
  '@keyframes loading-indicator-spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

const LoadingIndicator = ({ className, withBackground = true }) => (
  <Div_Wrapper className={className} withBackground={withBackground}>
    <svg
      className="loading-indicator-spinner"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM4 20C4 28.8366 11.1634 36 20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20Z"
        fill="#E5E4E8"
      />
      <path
        d="M20 2C20 0.895431 20.8977 -0.0103629 21.9967 0.0999093C25.2469 0.426009 28.3786 1.5446 31.1114 3.37061C34.4004 5.56824 36.9638 8.69181 38.4776 12.3463C39.9913 16.0009 40.3874 20.0222 39.6157 23.9018C38.844 27.7814 36.9392 31.3451 34.1421 34.1421C31.3451 36.9392 27.7814 38.844 23.9018 39.6157C20.0222 40.3874 16.0009 39.9913 12.3463 38.4776C8.69181 36.9638 5.56823 34.4004 3.37061 31.1114C1.5446 28.3786 0.426008 25.2469 0.0999093 21.9967C-0.0103629 20.8977 0.895431 20 2 20C3.10457 20 3.98712 20.8989 4.12483 21.9948C4.43365 24.4525 5.31026 26.8145 6.69649 28.8891C8.45459 31.5203 10.9534 33.5711 13.8771 34.7821C16.8007 35.9931 20.0177 36.3099 23.1214 35.6926C26.2251 35.0752 29.0761 33.5513 31.3137 31.3137C33.5513 29.0761 35.0752 26.2251 35.6926 23.1214C36.3099 20.0177 35.9931 16.8007 34.7821 13.8771C33.5711 10.9534 31.5203 8.45459 28.8891 6.69649C26.8145 5.31026 24.4525 4.43365 21.9948 4.12483C20.8989 3.98712 20 3.10457 20 2Z"
        fill="#A282EE"
      />
    </svg>
  </Div_Wrapper>
);

LoadingIndicator.propTypes = {
  className: PropTypes.string,
  withBackground: PropTypes.bool,
};

export default LoadingIndicator;
